var __jsx = React.createElement;
import React, { createContext, useContext } from 'react';
import { CopyProvider } from '@webtv/copy-provider';
import { getTLD, toGetLocale } from './locale';
import { jsx as _jsx } from "react/jsx-runtime";
export var InternationalizeProvider = function InternationalizeProvider(_ref) {
  var page = _ref.page,
      pelotonPlatform = _ref.pelotonPlatform,
      _ref$showLoadingSpinn = _ref.showLoadingSpinner,
      showLoadingSpinner = _ref$showLoadingSpinn === void 0 ? true : _ref$showLoadingSpinn,
      children = _ref.children;
  return /*#__PURE__*/_jsx(LocaleProvider, {
    pelotonPlatform: pelotonPlatform,
    children: /*#__PURE__*/_jsx(CopyProvider, {
      page: page,
      getLocale: toGetLocale(pelotonPlatform),
      showLoadingSpinner: showLoadingSpinner,
      children: children
    })
  });
};
var CONTEXT = /*#__PURE__*/createContext([{
  pelotonPlatform: ''
}, function () {
  return null;
}]);
export var LocaleProvider = function LocaleProvider(_ref2) {
  var children = _ref2.children,
      pelotonPlatform = _ref2.pelotonPlatform;
  return /*#__PURE__*/_jsx(CONTEXT.Provider, {
    value: [{
      pelotonPlatform: pelotonPlatform
    }, function () {
      return null;
    }],
    children: children
  });
};
export var useGetLocale = function useGetLocale() {
  var _useContext = useContext(CONTEXT),
      pelotonPlatform = _useContext[0].pelotonPlatform;

  return toGetLocale(pelotonPlatform);
};
export var useLocale = function useLocale() {
  var _useContext2 = useContext(CONTEXT),
      pelotonPlatform = _useContext2[0].pelotonPlatform;

  var getLocale = toGetLocale(pelotonPlatform);
  return getLocale();
};
export var useTLD = function useTLD() {
  var _useContext3 = useContext(CONTEXT),
      pelotonPlatform = _useContext3[0].pelotonPlatform;

  var getLocale = toGetLocale(pelotonPlatform);
  return getTLD(getLocale());
};